import axios from 'axios'

export const saveProfile = data => {
    return axios.post('/ajax/profile/save', data)
}
export const changePassword = data => {
    return axios.post('/ajax/profile/change-password', data)
}
